<template>
  <b-card :class="'main'">
    <h1 v-if="!success">
      {{
        $t('pages.feedback.secondary_title', {
          buyer: buyerName.substr(0, buyerName.lastIndexOf(' ')),
          projecttitle: title,
          location,
        })
      }}
    </h1>
    <p v-if="!success">
      {{ $t('pages.feedback.description') }}
    </p>

    <section
      v-if="success"
      v-html="$t(`pages.feedback.confirmations.${sucessMessage}`)"
    />

    <b-card no-body v-if="!success">
      <div class="card-header">
        <h3 class="mt-2 text-center">
          <b-button
            variant="link"
            aria-description="Select another"
            title="Select another"
            @click="selection = null"
            v-if="
              (selection && parseInt(selection)) || selection === 'companyOther'
            "
          >
            <b-icon
              icon="arrow-left-circle"
              variant="primary"
              scale="5"
              class="p-2"
            />
          </b-button>
          {{ $t('pages.feedback.question') }}
        </h3>
      </div>

      <b-form action="#" @submit.prevent="reportProjectData">
        <b-list-group flush>
          <b-list-group-item>
            <b-button-group class="mb-3">
              <b-button
                v-for="(company, index) in companies"
                :key="index"
                @click="selection = company.userId"
                :aria-describedby="
                  $t('pages.feedback.select_provider') + company.companyName
                "
                :variant="selection === company.userId ? 'primary' : ''"
                >{{ company.companyName }}</b-button
              >
              <b-button
                @click="selection = 'companyOther'"
                :variant="selection === 'companyOther' ? 'primary' : ''"
                >{{ $t('pages.feedback.other_provider') }}</b-button
              >
            </b-button-group>

            <section
              v-if="
                (selection && parseInt(selection)) ||
                  selection === 'companyOther'
              "
            >
              <b-alert show variant="primary">
                <i>{{ $t('pages.feedback.user_notice') }}</i>
              </b-alert>

              <b-form-group
                v-if="selection === 'companyOther'"
                label-cols="12"
                label-cols-sm="4"
                label-cols-lg="3"
                label-for="companyOther"
                :label="$t('pages.feedback.other_provider_name_label') + ':'"
              >
                <b-input
                  type="text"
                  v-model="companyOther"
                  name="companyOther"
                  :placeholder="$t('pages.feedback.other_provider')"
                  :required="selection === 'companyOther' ? true : false"
                ></b-input>
              </b-form-group>

              <b-form-group
                label-cols="12"
                label-cols-sm="4"
                label-cols-lg="3"
                label-for="indicativePrice"
                :label="$t('pages.feedback.indicative_price') + ':'"
              >
                <b-input
                  type="number"
                  :min="0"
                  :oninput="'validity.valid||(value=\'\');'"
                  :aria-describedby="$t('pages.feedback.indicative_price')"
                  @click="(e) => (e.target.value = '')"
                  id="indicativePrice"
                  v-model="indicativePrice"
                ></b-input>
                {{ currency | currencySymbol }}

                <b-form-text v-if="sumTotalCostVAT() > 0">
                <b-badge variant="primary">{{ sumTotalCostVAT() | currency(currency) }}</b-badge>
                {{ $t('quote_form.total_cost_vat_desc') }} ({{ vat }}%)
                </b-form-text>
              </b-form-group>

              <b-form-group
                v-if="selection !== 'companyOther'"
                label-cols="12"
                label-cols-sm="4"
                label-cols-lg="3"
                label-for="review"
                :label="$t('pages.feedback.leave_feedback_label') + ':'"
              >
                <b-input-group>
                  <b-form-textarea
                    id="review"
                    :maxlength="1000"
                    v-model="review"
                    :placeholder="
                      $t('pages.feedback.leave_feedback_placeholder')
                    "
                    rows="4"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>

              <b-tooltip target="indicativePrice" triggers="hover">
                <p>{{ $t('pages.feedback.excl_VAT') }}</p>
                <p>{{ $t('pages.feedback.sum_before_discounts') }}</p>
              </b-tooltip>
            </section>

            <section
              v-if="
                selection === null ||
                  selection === 'remind' ||
                  selection === 'republish' ||
                  selection === 'cancelled'
              "
            >
              <b-button-group>
                <b-button
                  @click="selection = 'remind'"
                  :variant="selection === 'remind' ? 'primary' : 'light'"
                  >{{ $t('pages.feedback.option_remind') }}</b-button
                >

                <b-button
                  @click="selection = 'republish'"
                  :variant="selection === 'republish' ? 'primary' : 'light'"
                  >{{ $t('pages.feedback.option_not_decided') }}</b-button
                >

                <b-button
                  :variant="selection === 'cancelled' ? 'primary' : 'light'"
                  @click="selection = 'cancelled'"
                >
                  {{ $t('pages.feedback.option_not_current') }}</b-button
                >
              </b-button-group>
              <p>
                <small class="text-muted" v-if="selection === 'republish'">{{
                  $t('pages.feedback.republished_label')
                }}</small>
              </p>
            </section>
          </b-list-group-item>
        </b-list-group>

        <b-button
          variant="primary"
          type="submit"
          class="block"
          :disabled="submitted"
          v-if="selection"
          >{{ $t('buttons.save_data') }}</b-button
        >
      </b-form>
      <b-card-footer>
        <small class="text-muted">
          <i
            >{{ $t('pages.feedback.disclaimer') }}
            <b-link :href="`mailto:${$t('menu.support_email')}`">{{
              $t('pages.feedback.mail_us')
            }}</b-link
            >.</i
          >
        </small>
      </b-card-footer>
    </b-card>
  </b-card>
</template>
<script>
import api from '../api/api';

export default {
  metaInfo() {
    return {
      title: this.$t('pages.feedback.title'),
    };
  },
  data() {
    return {
      companies: [],
      indicativePrice: 0,
      selection: null,
      companyOther: null,
      review: null,
      title: null,
      location: null,
      buyerName: null,
      currency: null,
      success: false,
      sucessMessage: 'company_selected',
      submitted: false,
    };
  },
  mounted() {
    this.getProjectUserData();
  },
  methods: {
    getProjectUserData() {
      api.getProjectUserData(this.$route.params.user_token).then((res) => {
        this.title = res.data.title;
        this.location = res.data.location;
        this.buyerName = res.data.buyerName;
        this.currency = res.data.userDataArray[0].currency;
        this.companies = res.data.userDataArray;
        localStorage.setItem('lang', res.data.userDataArray[0].language);
      });
    },
    reportProjectData() {
      this.submitted = true;
      let userId = 0;

      switch (this.selection) {
        case 'cancelled':
          userId = -3;
          this.sucessMessage = this.selection;
          break;
        case 'republish':
          userId = -2;
          this.sucessMessage = this.selection;
          break;
        case 'remind':
          userId = -1;
          this.sucessMessage = this.selection;
          break;
        case 'companyOther':
          break;
        default:
          userId = this.selection;
          break;
      }

      api
        .reportProjectData(this.$route.params.user_token, {
          userId: userId,
          companyName: this.companyOther,
          totalCost: this.indicativePrice || 0,
          notification: this.review,
        })
        .then(() => {
          this.success = true;
        })
        .finally(() => (this.submitted = false));
    },
     sumTotalCostVAT() {
      return Math.round(
        (parseInt(this.indicativePrice) || 0) +
          ((parseInt(this.indicativePrice) || 0) / 100) * 25,
      );
    },
  },
};
</script>
<style lang="scss" src="../assets/scss/feedback.scss" scoped />
